import React from 'react';
import ReactDOM from 'react-dom';
import Tab from "./Tab";
import MiniPlayer from "./AudioPlayer";
import HallowComponent from "./HallowComponent";
import HallowImage from "./HallowImage";
import Prayer from "./Prayer";
import { HALLOW_TABS as TABS} from "./Tab";
import "./index.css";
/*
class App extends React.Component { // we don't need HallowComponent functionality here
    render() {
        return (<div>
            <Tab type={TABS.home} key='homeTab' myKey='homeTab' />
            <Tab type={TABS.meditate} key='meditateTab' myKey='meditateTab' />
            <Tab type={TABS.sleep} key='sleepTab' myKey='sleepTab' />
            <Tab type={TABS.music} key='musicTab' myKey='musicTab' />
            <Tab type={TABS.library} key='libraryTab' myKey='libraryTab' />
            <MiniPlayer key='miniPlayer' myKey='miniPlayer' />
        </div>);
    }
}

ReactDOM.render(<App />, document.getElementById('root'));
*/
const myExports = { HallowComponent, HallowImage, Prayer };
export default myExports;